import {
  getSpecificMonthOfTheYear,
  toDayMonthYear,
} from '../../shared/helpers';
import toISOStringWithTimezone from '../../shared/utils/toISOStringWithTimezone';

interface LabelProps {
  reportType: string;
  startDate?: Date;
  endDate?: Date;
}

const overviewLabel = ({ reportType, startDate, endDate }: LabelProps) => {
  let label: string = '';

  if (reportType === 'Previous Month') {
    // set to -1 to get previous month
    label = `: ${getSpecificMonthOfTheYear(-1)}`;
  }

  if (reportType === 'This Month') {
    // set to zero to get current month
    label = `: ${getSpecificMonthOfTheYear(0)}`;
  }

  // custom date range
  if (reportType.includes('Custom Date Range') && startDate && endDate) {
    label = `: ${toDayMonthYear(
      toISOStringWithTimezone(startDate, 'start'),
    )} - ${toDayMonthYear(toISOStringWithTimezone(endDate, 'end'))}`;
  }

  return label;
};

export default overviewLabel;
